import * as React from 'react'

import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'

const questionsTemplateContext = React.createContext<{
  isDefault: boolean
  isCore: boolean
  isScore: boolean
} | null>(null)

const QuestionsTemplateProvider = questionsTemplateContext.Provider
interface Props {
  questionsTemplateId: string
}

export const QuestionsTemplateContextProvider = ({
  children,
  questionsTemplateId,
}: React.PropsWithChildren<Props>) => {
  const isDefault =
    questionsTemplates.find({
      id: questionsTemplateId,
    })?.isDefault ?? false

  const isCore =
    questionsTemplates.find({
      id: questionsTemplateId,
    })?.isCore ?? false

  const isScore =
    questionsTemplates.find({
      id: questionsTemplateId,
    })?.isScore ?? false

  return (
    <QuestionsTemplateProvider
      value={{
        isDefault,
        isCore,
        isScore,
      }}
    >
      {children}
    </QuestionsTemplateProvider>
  )
}

export const useQuestionsTemplate = () => {
  const templateContext = React.useContext(questionsTemplateContext)

  if (!templateContext) {
    throw new Error('useQuestionsTemplate must be used within a QuestionsTemplateProvider')
  }

  return templateContext
}
